export const ARCGIS_SW_LAND_LOT_COVERAGE_LAYER = 'ARCGIS_SW_LAND_LOT_COVERAGE_LAYER'
export const ARCGIS_INSPECTION_COMMS_LAYER = 'ARCGIS_INSPECTION_COMMS_LAYER'
